import { ThemeContext } from "@emotion/react";
import { Alert, Autocomplete, Backdrop, Box, Button, Chip, Fade, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material"
import { useContext, useEffect, useRef, useState } from "react";
import { VerifyMov } from "../../../../../hooks/verifyMov";
import swal from "sweetalert2";
import { EstatusMovimientoEnum } from "../../../../../@enums/status_mov_inv";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { MergeContainers } from "../../../../../hooks/merge-split";
import { TicketLocal } from "../../../../../hooks/sendPrint";
import { ModalConfirmacionTag } from "./modalConfirmacionTag";
import { set } from "react-hook-form";
import { GetClientsList } from "../../../../../hooks/getListClientes";
import { GetPartsClientsList } from "../../../../../hooks/getPartesClienteList";
import validateNumber from "../../../../../helpers/validateInt";
import { useSnackbar } from "notistack";

export const ModalMerge = ({ open, setOpen, almacen }) => {

  const style = {
    position: "absolute",
    top: "43%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 500,
    maxWidth: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    display: "flex",
    justifyContent: "center",
  };
  const formData = useRef(null);
  const inputRefMerge = useRef(null);
  const inputContenedores = useRef(null);
  const { setAppLoading } = useLoading();
  const theme = useContext(ThemeContext);
  const { verifyMovMutation } = VerifyMov();
  const { mergeContainersMutation } = MergeContainers();
  const { ticketLocalMutation } = TicketLocal();
  const { enqueueSnackbar } = useSnackbar();
  const { isLoading: isLoadingClients, isError: isErrorClients, data: clients, refetch: refetchClients } = GetClientsList();
  const [clienteSelect, setClientSelect] = useState(null);
  const { isLoading: isLoadingParts, isError: isErrorParts, data: parts = [], refetch: refetchParts } = GetPartsClientsList(clienteSelect?.value);
  const [parte, setParte] = useState(null);
  const [seccion, setSeccion] = useState(1);
  const [seccionMerge, setSeccionMerge] = useState(1);
  const [paquetes, setPaquetes] = useState([]);
  const [paqueteSplit, setPaqueteSplit] = useState(null);
  const [contenedores, setContenedores] = useState(0);
  const [alertSplit, setAlertSplit] = useState(false);
  const [tipoSplit, setTipoSplit] = useState(1);
  const [cantidad, setCantidad] = useState(null);
  const [restante, setRestante] = useState(null);
  const printerId = useSelector((state) => state.app.printerId);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [dataReprint, setDataReprint] = useState([]);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (inputRefMerge.current) {
          inputRefMerge.current.focus();
        }
      }, 200); // Esperar un corto tiempo para asegurarse de que el modal esté completamente renderizado
    }
  }, [open]);


  const handleClose = () => {
    setOpen(false);
    setPaquetes([]);
    setDataReprint([]);
    setOpenConfirm(false);
    setPaqueteSplit(null);
    setAlertSplit(false);
    setContenedores(0);
    setSeccionMerge(1);
    setClientSelect(null);
    setParte(null);
    setSeccion(1);
    setTipoSplit(1);
    setRestante(null);
    setCantidad(null)
  }
  const changeSeccion = (e) => {
    setSeccion(parseInt(e.target.value));
    setPaquetes([]);
    setPaqueteSplit(null);
    setAlertSplit(false);
    setParte(null);
    setClientSelect(null);
    setTipoSplit(1);
    setRestante(null);
  }
  const changeSeccionMerge = (e) => {
    setSeccionMerge(parseInt(e.target.value));
    setPaquetes([]);
    setParte(null);
    setClientSelect(null);
  }
  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      setAppLoading(true)
      event.preventDefault();
      if (paquetes.some((item) => item.tag === event.target.value)) {
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "warning",
          title: "El contenedor ya ha sido agregado",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      } else {
        let body = {
          moin_estatus: EstatusMovimientoEnum.ACTIVO,
          alma_entrada: almacen,
          movimientos_inventario_etiquetas: {
            etiquetas: {
              etiq_estatus: true,
              etiq_codigo: event.target.value,
              etiq_padreid: null,
              etiq_ismaster: false
            }
          }
        };
        verifyMovMutation({ where: body, validate_master: true, where_master: {} }, {
          onSuccess: (data) => {
            setAppLoading(false)
            if (data.success !== false && (paquetes.length === 0 || (paquetes.length > 0 && data?.data?.parte === paquetes[0].parte))) {
              if (seccion === 1) {
                setPaquetes([
                  ...paquetes,
                  {
                    ...data.data,
                  },
                ]);
                formData.current.etiqueta.value = "";
                inputRefMerge.current.focus();
              } else {
                setPaqueteSplit(data?.data);
                calculateSplit(data?.data?.cantidad, contenedores)
                setCantidad(data?.data?.cantidad)
                if (seccion === 2 && tipoSplit === 2) {
                  setRestante(data?.data?.cantidad)
                }
                inputContenedores.current.focus();
              }
            } else {
              swal.fire({
                position: "center",
                icon: "error",
                title:
                  "El contenedor no existe o no cumple con las condiciones necesarias",
                width: 600,
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  container: "cont_alt",
                },
              });
              inputRefMerge.current.focus();
            }
          },
          onError: (error) => {
            setAppLoading(false)
            swal.fire({
              position: "center",
              icon: "error",
              title:
                "El contenedor no existe o no cumple con las condiciones necesarias",
              width: 600,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                container: "cont_alt",
              },
            });
            inputRefMerge.current.focus();
          },
        });
      }
    }
  };
  const handleChangeClient = (newValue) => {
    setParte(null);
    if (newValue === null) {
      setClientSelect(null);
    } else {
      setClientSelect(newValue);
    }
  }
  const handleChangePart = (newValue) => {
    if (newValue === null) {
      setParte(null);
    } else {
      setParte(newValue);
    }
  }
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const handleEnterParte = () => {
    setAppLoading(true);
    let body = {
      moin_estatus: EstatusMovimientoEnum.ACTIVO,
      alma_entrada: almacen,
      part_id: parte?.value,
      movimientos_inventario_etiquetas: {
        etiquetas: {
          etiq_estatus: true
        }
      }
    };
    verifyMovMutation({ where: body, validate_master: true, where_master: {}, byParte: true }, {
      onSuccess: (data) => {
        if (data.success !== false) {
          let news = data?.data?.map(i => {
            return {
              id: i?.id,
              tag: i?.tag,
              tag_id: i?.tag_id,
              cantidad: i?.cantidad
            }
          })
          console.log(news)
          setPaquetes([
            ...paquetes,
            ...news
          ]);
          setAppLoading(false)
        } else {
          setAppLoading(false)
          swal.fire({
            position: "center",
            icon: "error",
            title:
              "El contenedor no existe o no cumple con las condiciones necesarias",
            width: 600,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              container: "cont_alt",
            },
          });
        }
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "error",
          title:
            "El contenedor no existe o no cumple con las condiciones necesarias",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      },
    });
  }
  const changeCantidad = (e) => {
    if (e.target.value === '') {
      setContenedores(0);
      calculateSplit(paqueteSplit?.cantidad, 0)
    } else {
      let cantidad = parseInt(e.target.value)
      setContenedores(cantidad)
      if (paqueteSplit !== null) {
        calculateSplit(paqueteSplit?.cantidad, cantidad)
      }
    }
  }
  const deleteItem = (index) => {
    let paq = paquetes;
    if (seccion === 2 && tipoSplit === 2) {
      setRestante(restante + paq[index].cantidad)
    }
    paq.splice(index, 1);
    setPaquetes([...paq]);
  }
  const changeTipoSplit = (value) => {
    setPaquetes([]);
    setContenedores(0);
    setTipoSplit(value);
    value === 1 ? setRestante(null) : setRestante(cantidad);
  };
  const fillDataIrregular = (value) => {
    let piezas_paq = value;
    if (piezas_paq !== "") {
      let new_value = parseInt(value)
      let total = paquetes.reduce((acumulador, valorActual) => acumulador + valorActual?.cantidad, 0);
      let rest = cantidad - total
      if (rest > 0) {
        if (new_value > rest) {
          paquetes.push({ cantidad: cantidad - total })
          setRestante(0)
        } else {
          paquetes.push({ cantidad: new_value })
          setRestante(cantidad - (total + new_value))
        }
      }
    }
    formData.current[`total_cantidad_irr`].value = "";
  }

  const calculateSplit = (cantidad_split, total_contenedores) => {
    let total = cantidad_split;
    let cantidad_contenedores = total_contenedores;
    if (cantidad_contenedores > 0) {
      let paq = new Array(cantidad_contenedores);
      let cociente = Math.floor(total / cantidad_contenedores);
      let residuo = total % cantidad_contenedores;
      paq.fill({ cantidad: cociente });
      if (residuo > 0) {
        paq.push({ cantidad: residuo });
        setAlertSplit(true)
      } else {
        setAlertSplit(false)
      };
      setPaquetes(paq)
    } else {
      setPaquetes([]);
    };
  }

  const sendData = () => {
    if (seccion === 2 && tipoSplit === 2 && (restante > 0 || restante === null)) {
      enqueueSnackbar("Aun no se completa la cantidad del split", {
        autoHideDuration: 2000,
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    } else {
      setAppLoading(true)
      let body = {
        printerId: printerId,
        almacenOrigen: almacen,
        tipo: seccion,
        data: paquetes,
        tag: paqueteSplit?.tag_id
      }
      mergeContainersMutation(body, {
        onSuccess: (data) => {
          for (let print of data?.data) {
            ticketLocalMutation(print, {
              onSuccess: (data) => {
                console.log(data)
              },
              onError: (error) => {
                console.log(error)
              }
            })
          }
          setDataReprint(data?.data);
          // data?.data?.length > 0 ? setOpenConfirm(true) : handleClose();
          handleClose();
          setAppLoading(false);
        },
        onError: (error) => {
          console.log(error);
          handleClose();
          setAppLoading(false)
        }
      })
    }

  }

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="modal_merge">
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sx={{ p: 0, mb: 1, pr: 1 }}
                className="center_item"
              >
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  {
                    `
                  ${seccion === 1 ? 'Merge' : 'Split'}
                  de Contenedores
                  `
                  }
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={4}
                xl={4}
                sx={{
                  p: 1,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: "column",
                }}
              >
                <form ref={formData} id="form_dom" style={{ width: "100%" }}>
                  <FormControl sx={{ mb: 2 }}>
                    <RadioGroup
                      aria-labelledby="radio_merge"
                      name="radio_merge"
                      value={seccion}
                      onChange={changeSeccion}
                      row
                    >
                      <FormControlLabel value={1} control={<Radio />} label="Merge" />
                      <FormControlLabel value={2} control={<Radio />} label="Split" />
                    </RadioGroup>
                  </FormControl>
                  {seccion === 1 &&
                    <FormControl sx={{ mb: 2 }}>
                      <RadioGroup
                        aria-labelledby="radio_merge_seccion"
                        name="radio_merge_seccion"
                        value={seccionMerge}
                        onChange={changeSeccionMerge}
                        row
                      >
                        <FormControlLabel value={1} control={<Radio />} label="Etiqueta" />
                        <FormControlLabel value={2} control={<Radio />} label="Parte" />
                      </RadioGroup>
                    </FormControl>}
                  {
                    ((seccion === 1 && seccionMerge === 1) || seccion === 2) &&
                    <TextField
                      id="etiqueta"
                      size="small"
                      label="Etiqueta"
                      fullWidth
                      inputRef={inputRefMerge}
                      onKeyDown={handleEnterPress}
                      disabled={paqueteSplit !== null && seccion === 2}
                      sx={{ color: theme.palette.primary.input, width: "100%" }}
                    />
                  }
                  {
                    seccion === 1 && seccionMerge === 2 &&
                    <>
                      <Autocomplete
                        fullWidth
                        id="emp_id"
                        getOptionLabel={(opcion) => opcion.label}
                        filterSelectedOptions
                        options={clients}
                        onKeyDown={handleKeyUp}
                        value={clienteSelect}
                        onChange={(e, newValue) => handleChangeClient(newValue)}
                        renderOption={(props, option) => (
                          <Box {...props} key={option?.value}>{option.label}</Box>
                        )}
                        renderInput={(params) =>
                          <TextField {...params} label="Cliente" size="small" fullWidth required />
                        }
                      />

                      <Autocomplete
                        fullWidth
                        id="part_id"
                        getOptionLabel={(opcion) =>
                          opcion?.codigo !== undefined ?
                            `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}` :
                            opcion?.label
                        }
                        sx={{ mt: 2 }}
                        filterSelectedOptions
                        options={parts}
                        onKeyDown={handleKeyUp}
                        value={parte}
                        disabled={!parts || !clienteSelect}
                        onChange={(e, newValue) => handleChangePart(newValue)}
                        renderOption={(props, option) => (
                          <Box {...props} key={option?.value}>
                            {option?.codigo !== undefined ? option?.codigo : <></>} /
                            {option?.codigo_salida !== undefined ? option?.codigo_salida : <></>} /
                            {option?.codigo_alterno !== undefined ? option?.codigo_alterno : <></>} / {option?.label}
                          </Box>
                        )}
                        renderInput={(params) =>
                          <TextField {...params} label="Parte" size="small" fullWidth required />
                        }
                      />
                      <Button
                        variant="contained"
                        className="btn_system"
                        sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                        disableElevation
                        disabled={!parte}
                        onClick={handleEnterParte}
                      >
                        Buscar
                      </Button>
                    </>
                  }
                  {
                    seccion === 2 &&
                    <>
                      <FormControl fullWidth size="small" sx={{ width: "100%", mt: 2 }}>
                        <InputLabel id="select-split">Tipo registro</InputLabel>
                        <Select
                          labelId="select-split"
                          id="tipo_spliteo"
                          name="tipo_spliteo"
                          label="Tipo Spliteo"
                          value={tipoSplit}
                          onChange={(e) => changeTipoSplit(parseInt(e.target.value))}
                          required
                        >
                          <MenuItem value={1}>Regular</MenuItem>
                          <MenuItem value={2}>Irregular</MenuItem>
                        </Select>
                      </FormControl>
                      {
                        tipoSplit === 1 &&
                        <TextField
                          type="number"
                          id="number_split"
                          size="small"
                          label="N° de contenedores"
                          fullWidth
                          inputRef={inputContenedores}
                          onChange={changeCantidad}
                          sx={{ color: theme.palette.primary.input, width: "100%", mt: 2 }}
                        />
                      }
                      {
                        tipoSplit === 2 &&
                        <>
                          <TextField
                            id={`total_cantidad_irr`}
                            size="small"
                            label="Cantidad"
                            fullWidth
                            required
                            disabled={cantidad === null}
                            onKeyDown={(e) => validateNumber(e)}
                            onKeyUp={(e) => {
                              if (e.key === "Enter") {
                                fillDataIrregular(e.target.value);
                              }
                            }}
                            sx={{ color: theme.palette.primary.input, width: "100%", mt: 2 }}
                          />
                          <span key={`rest_${restante}`}>Restante: {restante} </span>
                        </>
                      }
                    </>
                  }
                  <Button
                    variant="contained"
                    className="btn_system"
                    sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                    disableElevation
                    disabled={paquetes.length === 0}
                    onClick={sendData}
                  >
                    {
                      seccion === 1 ?
                        'Merge' :
                        'Split'
                    }
                  </Button>
                </form>
              </Grid>
              <Grid
                item
                key='column_paquetes'
                xs={12}
                sm={12}
                md={12}
                lg={8}
                xl={8}
                sx={{
                  p: 1,
                  gap: 2,
                  display: "flex",
                  alignItems: "flex-start",
                  width: '100%'
                }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ width: '100%' }}
                >
                  {
                    alertSplit &&
                    <Grid item xs={12} key='alert_split' sx={{ mb: 2 }}>
                      <Alert severity="warning" style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
                        El numero de contenedores genera un contenedor residuo
                      </Alert>
                    </Grid>
                  }
                  {
                    paqueteSplit !== null &&
                    <Grid item xs={12} key='total_split' sx={{ mb: 0.5, p: 0.5 }}>
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          padding: 0,
                          height: '30px'
                        }}
                      >
                        <p style={{ padding: 0 }}>
                          Cantidad total:
                          <span style={{ fontWeight: 600 }}> {paqueteSplit?.cantidad}</span>
                        </p>
                      </div>
                    </Grid>
                  }
                  <Grid
                    item
                    xs={12}
                    sx={{
                      p: 1,
                      border: "1px solid #D9D9D9",
                      borderRadius: 5,
                    }}
                  >
                    <Grid
                      container
                      spacing={0}
                      sx={{
                        width: '100%',
                        minHeight: '150px',
                        maxHeight: '400px',
                        overflowY: 'scroll'
                      }}
                    >
                      {paquetes?.map((paq, index) => (
                        <>
                          {
                            <Grid
                              item
                              xs={6}
                              sx={{
                                p: 1,
                                textAlign: "start",
                                display: "flex",
                                alignItems: "flex-start",
                                alignContent: 'flex-start',
                                width: '100%',
                                height: '50px'
                              }}
                            >
                              <Chip
                                label={
                                  <div
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        marginRight: 7,
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "black",
                                      }}
                                    >
                                      {paq?.cantidad}
                                    </span>
                                    {
                                      seccion === 1 &&
                                      <span
                                        style={{
                                          marginLeft: 7,
                                          border: "1px solid #575E3B",
                                          borderRadius: 4,
                                          fontSize: 11,
                                          padding: 3,
                                          color: "#575E3B",
                                        }}
                                      >
                                        {paq?.tag}
                                      </span>
                                    }
                                  </div>
                                }
                                variant="outlined"
                                deleteIcon={
                                  <Delete sx={{ marginLeft: "5px !important", width: 18 }} />
                                }
                                onDelete={
                                  (seccion === 1 || (seccion === 2 && tipoSplit === 2)) ?
                                    () => deleteItem(index) :
                                    null
                                }
                                sx={{
                                  height: 40,
                                  borderRadius: 2,
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                  backgroundColor: "transparent",
                                }}
                              />
                            </Grid>
                          }
                        </>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      {/* <ModalConfirmacionTag key="modal_confirm" open={openConfirm} setOpen={setOpenConfirm} dataReprint={dataReprint} onClose={handleClose} /> */}
    </>
  )
}